import React from 'react';
import { SOSAlert, useWalkie } from '../contexts/WalkieContext';

interface SOSAlertBannerProps {
  alerts: SOSAlert[];
}

export default function SOSAlertBanner({ alerts }: SOSAlertBannerProps) {
  const { resolveSOS } = useWalkie();

  return (
    <div className="flex flex-col gap-2 px-4 py-2">
      {alerts.map(alert => {
        const mapsUrl = `https://www.google.com/maps?q=${alert.lat},${alert.lng}&z=18`;
        const timeStr = new Date(alert.timestamp).toLocaleTimeString('ar-SA', {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        });

        return (
          <div
            key={alert.id}
            className="sos-pulse rounded-lg px-6 py-4 flex items-center justify-between text-white fade-in"
            dir="rtl"
          >
            {/* Left: SOS info */}
            <div className="flex items-center gap-4">
              <span className="text-3xl">🆘</span>
              <div>
                <div className="text-xl font-bold">
                  SOS — {alert.guardName}
                </div>
                <div className="text-sm text-red-100">
                  القناة: {alert.channelName} • الوقت: {timeStr}
                </div>
              </div>
            </div>

            {/* Center: GPS */}
            <a
              href={mapsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 bg-white/20 hover:bg-white/30 px-4 py-2 rounded-lg transition-colors text-sm font-semibold"
            >
              📍 عرض الموقع على الخريطة
            </a>

            {/* Right: Resolve button */}
            <button
              onClick={() => resolveSOS(alert.id)}
              className="bg-gray-900 hover:bg-gray-800 px-6 py-2 rounded-lg font-bold transition-colors"
            >
              ✓ إغلاق الاستغاثة
            </button>
          </div>
        );
      })}
    </div>
  );
}
